import React from 'react';
import { connect } from 'react-redux';
import { toggleSubscription } from '../actions/subscriptionActions';
import { withTranslation } from "react-i18next";

import ARSwitch from '../react/shared/components/forms/ARSwitch/ARSwitch';

class OptOutSwitch extends React.Component {
  handleToggle = (checked) => {
    var isOptOut = 1;
    if(checked) {
      isOptOut = 0;
    }
    this.props.toggleSubscription(isOptOut);
  }
  
  render() {
    var { t,isChecked, isSaving } = this.props;
    var optionalProps = {};
    if(isSaving) {
      optionalProps.disabled = true;
    }
    return (
      <ARSwitch 
        onChange={this.handleToggle}
        checkedChildren={t('toggleYes')}
        unCheckedChildren={t('toggleNo')}
        defaultChecked={isChecked}
        {...optionalProps}
      />
    );
  }
}

const mapStateToProps = state => ({
  isChecked: !state.status.selected,
  isSaving: state.status.isSaving
});
export default connect(mapStateToProps,{ toggleSubscription })(withTranslation()(OptOutSwitch));